import _defineProperty from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/regenerator/index.js";
var teardownPlaceholder = function teardownPlaceholder() {};
var e = teardownPlaceholder;
function start(e) {
  return {
    tag: 0,
    0: e
  };
}
function push(e) {
  return {
    tag: 1,
    0: e
  };
}
var identity = function identity(e) {
  return e;
};
function buffer(r) {
  return function (t) {
    return function (i) {
      var a = [];
      var f = e;
      var n = e;
      var s = !1;
      var l = !1;
      t(function (e) {
        if (l) {} else if (0 === e) {
          l = !0;
          n(1);
          if (a.length) {
            i(push(a));
          }
          i(0);
        } else if (0 === e.tag) {
          f = e[0];
          r(function (e) {
            if (l) {} else if (0 === e) {
              l = !0;
              f(1);
              if (a.length) {
                i(push(a));
              }
              i(0);
            } else if (0 === e.tag) {
              n = e[0];
            } else if (a.length) {
              var r = push(a);
              a = [];
              i(r);
            }
          });
        } else {
          a.push(e[0]);
          if (!s) {
            s = !0;
            f(0);
            n(0);
          } else {
            s = !1;
          }
        }
      });
      i(start(function (e) {
        if (1 === e && !l) {
          l = !0;
          f(1);
          n(1);
        } else if (!l && !s) {
          s = !0;
          f(0);
          n(0);
        }
      }));
    };
  };
}
function concatMap(r) {
  return function (t) {
    return function (i) {
      var a = [];
      var f = e;
      var n = e;
      var s = !1;
      var l = !1;
      var u = !1;
      var o = !1;
      function applyInnerSource(e) {
        u = !0;
        e(function (e) {
          if (0 === e) {
            if (u) {
              u = !1;
              if (a.length) {
                applyInnerSource(r(a.shift()));
              } else if (o) {
                i(0);
              } else if (!s) {
                s = !0;
                f(0);
              }
            }
          } else if (0 === e.tag) {
            l = !1;
            (n = e[0])(0);
          } else if (u) {
            i(e);
            if (l) {
              l = !1;
            } else {
              n(0);
            }
          }
        });
      }
      t(function (e) {
        if (o) {} else if (0 === e) {
          o = !0;
          if (!u && !a.length) {
            i(0);
          }
        } else if (0 === e.tag) {
          f = e[0];
        } else {
          s = !1;
          if (u) {
            a.push(e[0]);
          } else {
            applyInnerSource(r(e[0]));
          }
        }
      });
      i(start(function (e) {
        if (1 === e) {
          if (!o) {
            o = !0;
            f(1);
          }
          if (u) {
            u = !1;
            n(1);
          }
        } else {
          if (!o && !s) {
            s = !0;
            f(0);
          }
          if (u && !l) {
            l = !0;
            n(0);
          }
        }
      }));
    };
  };
}
function concatAll(e) {
  return concatMap(identity)(e);
}
function concat(e) {
  return concatAll(r(e));
}
function filter(r) {
  return function (t) {
    return function (i) {
      var a = e;
      t(function (e) {
        if (0 === e) {
          i(0);
        } else if (0 === e.tag) {
          a = e[0];
          i(e);
        } else if (!r(e[0])) {
          a(0);
        } else {
          i(e);
        }
      });
    };
  };
}
function map(e) {
  return function (r) {
    return function (t) {
      return r(function (r) {
        if (0 === r || 0 === r.tag) {
          t(r);
        } else {
          t(push(e(r[0])));
        }
      });
    };
  };
}
function mergeMap(r) {
  return function (t) {
    return function (i) {
      var a = [];
      var f = e;
      var n = !1;
      var s = !1;
      t(function (t) {
        if (s) {} else if (0 === t) {
          s = !0;
          if (!a.length) {
            i(0);
          }
        } else if (0 === t.tag) {
          f = t[0];
        } else {
          n = !1;
          !function applyInnerSource(r) {
            var t = e;
            r(function (e) {
              if (0 === e) {
                if (a.length) {
                  var r = a.indexOf(t);
                  if (r > -1) {
                    (a = a.slice()).splice(r, 1);
                  }
                  if (!a.length) {
                    if (s) {
                      i(0);
                    } else if (!n) {
                      n = !0;
                      f(0);
                    }
                  }
                }
              } else if (0 === e.tag) {
                a.push(t = e[0]);
                t(0);
              } else if (a.length) {
                i(e);
                t(0);
              }
            });
          }(r(t[0]));
          if (!n) {
            n = !0;
            f(0);
          }
        }
      });
      i(start(function (e) {
        if (1 === e) {
          if (!s) {
            s = !0;
            f(1);
          }
          for (var r = 0, t = a, i = a.length; r < i; r++) {
            t[r](1);
          }
          a.length = 0;
        } else {
          if (!s && !n) {
            n = !0;
            f(0);
          } else {
            n = !1;
          }
          for (var l = 0, u = a, o = a.length; l < o; l++) {
            u[l](0);
          }
        }
      }));
    };
  };
}
function mergeAll(e) {
  return mergeMap(identity)(e);
}
function merge(e) {
  return mergeAll(r(e));
}
function onEnd(e) {
  return function (r) {
    return function (t) {
      var i = !1;
      r(function (r) {
        if (i) {} else if (0 === r) {
          i = !0;
          t(0);
          e();
        } else if (0 === r.tag) {
          var a = r[0];
          t(start(function (r) {
            if (1 === r) {
              i = !0;
              a(1);
              e();
            } else {
              a(r);
            }
          }));
        } else {
          t(r);
        }
      });
    };
  };
}
function onPush(e) {
  return function (r) {
    return function (t) {
      var i = !1;
      r(function (r) {
        if (i) {} else if (0 === r) {
          i = !0;
          t(0);
        } else if (0 === r.tag) {
          var a = r[0];
          t(start(function (e) {
            if (1 === e) {
              i = !0;
            }
            a(e);
          }));
        } else {
          e(r[0]);
          t(r);
        }
      });
    };
  };
}
function onStart(e) {
  return function (r) {
    return function (t) {
      return r(function (r) {
        if (0 === r) {
          t(0);
        } else if (0 === r.tag) {
          t(r);
          e();
        } else {
          t(r);
        }
      });
    };
  };
}
function sample(r) {
  return function (t) {
    return function (i) {
      var a = e;
      var f = e;
      var n;
      var s = !1;
      var l = !1;
      t(function (e) {
        if (l) {} else if (0 === e) {
          l = !0;
          f(1);
          i(0);
        } else if (0 === e.tag) {
          a = e[0];
        } else {
          n = e[0];
          if (!s) {
            s = !0;
            f(0);
            a(0);
          } else {
            s = !1;
          }
        }
      });
      r(function (e) {
        if (l) {} else if (0 === e) {
          l = !0;
          a(1);
          i(0);
        } else if (0 === e.tag) {
          f = e[0];
        } else if (void 0 !== n) {
          var r = push(n);
          n = void 0;
          i(r);
        }
      });
      i(start(function (e) {
        if (1 === e && !l) {
          l = !0;
          a(1);
          f(1);
        } else if (!l && !s) {
          s = !0;
          a(0);
          f(0);
        }
      }));
    };
  };
}
function scan(e, r) {
  return function (t) {
    return function (i) {
      var a = r;
      t(function (r) {
        if (0 === r) {
          i(0);
        } else if (0 === r.tag) {
          i(r);
        } else {
          i(push(a = e(a, r[0])));
        }
      });
    };
  };
}
function share(r) {
  var t = [];
  var i = e;
  var a = !1;
  return function (e) {
    t.push(e);
    if (1 === t.length) {
      r(function (e) {
        if (0 === e) {
          for (var r = 0, f = t, n = t.length; r < n; r++) {
            f[r](0);
          }
          t.length = 0;
        } else if (0 === e.tag) {
          i = e[0];
        } else {
          a = !1;
          for (var s = 0, l = t, u = t.length; s < u; s++) {
            l[s](e);
          }
        }
      });
    }
    e(start(function (r) {
      if (1 === r) {
        var f = t.indexOf(e);
        if (f > -1) {
          (t = t.slice()).splice(f, 1);
        }
        if (!t.length) {
          i(1);
        }
      } else if (!a) {
        a = !0;
        i(0);
      }
    }));
  };
}
function skip(r) {
  return function (t) {
    return function (i) {
      var a = e;
      var f = r;
      t(function (e) {
        if (0 === e) {
          i(0);
        } else if (0 === e.tag) {
          a = e[0];
          i(e);
        } else if (f-- > 0) {
          a(0);
        } else {
          i(e);
        }
      });
    };
  };
}
function skipUntil(r) {
  return function (t) {
    return function (i) {
      var a = e;
      var f = e;
      var n = !0;
      var s = !1;
      var l = !1;
      t(function (e) {
        if (l) {} else if (0 === e) {
          l = !0;
          if (n) {
            f(1);
          }
          i(0);
        } else if (0 === e.tag) {
          a = e[0];
          r(function (e) {
            if (0 === e) {
              if (n) {
                l = !0;
                a(1);
              }
            } else if (0 === e.tag) {
              (f = e[0])(0);
            } else {
              n = !1;
              f(1);
            }
          });
        } else if (!n) {
          s = !1;
          i(e);
        } else if (!s) {
          s = !0;
          a(0);
          f(0);
        } else {
          s = !1;
        }
      });
      i(start(function (e) {
        if (1 === e && !l) {
          l = !0;
          a(1);
          if (n) {
            f(1);
          }
        } else if (!l && !s) {
          s = !0;
          if (n) {
            f(0);
          }
          a(0);
        }
      }));
    };
  };
}
function skipWhile(r) {
  return function (t) {
    return function (i) {
      var a = e;
      var f = !0;
      t(function (e) {
        if (0 === e) {
          i(0);
        } else if (0 === e.tag) {
          a = e[0];
          i(e);
        } else if (f) {
          if (r(e[0])) {
            a(0);
          } else {
            f = !1;
            i(e);
          }
        } else {
          i(e);
        }
      });
    };
  };
}
function switchMap(r) {
  return function (t) {
    return function (i) {
      var a = e;
      var f = e;
      var n = !1;
      var s = !1;
      var l = !1;
      var u = !1;
      t(function (t) {
        if (u) {} else if (0 === t) {
          u = !0;
          if (!l) {
            i(0);
          }
        } else if (0 === t.tag) {
          a = t[0];
        } else {
          if (l) {
            f(1);
            f = e;
          }
          if (!n) {
            n = !0;
            a(0);
          } else {
            n = !1;
          }
          !function applyInnerSource(e) {
            l = !0;
            e(function (e) {
              if (!l) {} else if (0 === e) {
                l = !1;
                if (u) {
                  i(0);
                } else if (!n) {
                  n = !0;
                  a(0);
                }
              } else if (0 === e.tag) {
                s = !1;
                (f = e[0])(0);
              } else {
                i(e);
                if (!s) {
                  f(0);
                } else {
                  s = !1;
                }
              }
            });
          }(r(t[0]));
        }
      });
      i(start(function (e) {
        if (1 === e) {
          if (!u) {
            u = !0;
            a(1);
          }
          if (l) {
            l = !1;
            f(1);
          }
        } else {
          if (!u && !n) {
            n = !0;
            a(0);
          }
          if (l && !s) {
            s = !0;
            f(0);
          }
        }
      }));
    };
  };
}
function switchAll(e) {
  return switchMap(identity)(e);
}
function take(r) {
  return function (t) {
    return function (i) {
      var a = e;
      var f = !1;
      var n = 0;
      t(function (e) {
        if (f) {} else if (0 === e) {
          f = !0;
          i(0);
        } else if (0 === e.tag) {
          if (r <= 0) {
            f = !0;
            i(0);
            e[0](1);
          } else {
            a = e[0];
          }
        } else if (n++ < r) {
          i(e);
          if (!f && n >= r) {
            f = !0;
            i(0);
            a(1);
          }
        } else {
          i(e);
        }
      });
      i(start(function (e) {
        if (1 === e && !f) {
          f = !0;
          a(1);
        } else if (0 === e && !f && n < r) {
          a(0);
        }
      }));
    };
  };
}
function takeLast(t) {
  return function (i) {
    return function (a) {
      var f = [];
      var n = e;
      i(function (e) {
        if (0 === e) {
          r(f)(a);
        } else if (0 === e.tag) {
          if (t <= 0) {
            e[0](1);
            r(f)(a);
          } else {
            (n = e[0])(0);
          }
        } else {
          if (f.length >= t && t) {
            f.shift();
          }
          f.push(e[0]);
          n(0);
        }
      });
    };
  };
}
function takeUntil(r) {
  return function (t) {
    return function (i) {
      var a = e;
      var f = e;
      var n = !1;
      t(function (e) {
        if (n) {} else if (0 === e) {
          n = !0;
          f(1);
          i(0);
        } else if (0 === e.tag) {
          a = e[0];
          r(function (e) {
            if (0 === e) {} else if (0 === e.tag) {
              (f = e[0])(0);
            } else {
              n = !0;
              f(1);
              a(1);
              i(0);
            }
          });
        } else {
          i(e);
        }
      });
      i(start(function (e) {
        if (1 === e && !n) {
          n = !0;
          a(1);
          f(1);
        } else if (!n) {
          a(0);
        }
      }));
    };
  };
}
function takeWhile(r, t) {
  return function (i) {
    return function (a) {
      var f = e;
      var n = !1;
      i(function (e) {
        if (n) {} else if (0 === e) {
          n = !0;
          a(0);
        } else if (0 === e.tag) {
          f = e[0];
          a(e);
        } else if (!r(e[0])) {
          n = !0;
          if (t) {
            a(e);
          }
          a(0);
          f(1);
        } else {
          a(e);
        }
      });
    };
  };
}
function debounce(e) {
  return function (r) {
    return function (t) {
      var i;
      var a = !1;
      var f = !1;
      r(function (r) {
        if (f) {} else if (0 === r) {
          f = !0;
          if (i) {
            a = !0;
          } else {
            t(0);
          }
        } else if (0 === r.tag) {
          var n = r[0];
          t(start(function (e) {
            if (1 === e && !f) {
              f = !0;
              a = !1;
              if (i) {
                clearTimeout(i);
              }
              n(1);
            } else if (!f) {
              n(0);
            }
          }));
        } else {
          if (i) {
            clearTimeout(i);
          }
          i = setTimeout(function () {
            i = void 0;
            t(r);
            if (a) {
              t(0);
            }
          }, e(r[0]));
        }
      });
    };
  };
}
function delay(e) {
  return function (r) {
    return function (t) {
      var i = 0;
      r(function (r) {
        if (0 !== r && 0 === r.tag) {
          t(r);
        } else {
          i++;
          setTimeout(function () {
            if (i) {
              i--;
              t(r);
            }
          }, e);
        }
      });
    };
  };
}
function throttle(e) {
  return function (r) {
    return function (t) {
      var i = !1;
      var a;
      r(function (r) {
        if (0 === r) {
          if (a) {
            clearTimeout(a);
          }
          t(0);
        } else if (0 === r.tag) {
          var f = r[0];
          t(start(function (e) {
            if (1 === e) {
              if (a) {
                clearTimeout(a);
              }
              f(1);
            } else {
              f(0);
            }
          }));
        } else if (!i) {
          i = !0;
          if (a) {
            clearTimeout(a);
          }
          a = setTimeout(function () {
            a = void 0;
            i = !1;
          }, e(r[0]));
          t(r);
        }
      });
    };
  };
}
function lazy(e) {
  return function (r) {
    return e()(r);
  };
}
function fromAsyncIterable(e) {
  return function (r) {
    var t = e[Symbol.asyncIterator]();
    var i = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(1 === e)) {
                _context.next = 5;
                break;
              }
              i = !0;
              if (t.return) {
                t.return();
              }
              _context.next = 39;
              break;
            case 5:
              if (!a) {
                _context.next = 9;
                break;
              }
              f = !0;
              _context.next = 39;
              break;
            case 9:
              f = a = !0;
            case 10:
              if (!(f && !i)) {
                _context.next = 38;
                break;
              }
              _context.next = 13;
              return t.next();
            case 13:
              if (!(n = _context.sent).done) {
                _context.next = 21;
                break;
              }
              i = !0;
              if (!t.return) {
                _context.next = 18;
                break;
              }
              _context.next = 18;
              return t.return();
            case 18:
              r(0);
              _context.next = 36;
              break;
            case 21:
              _context.prev = 21;
              f = !1;
              r(push(n.value));
              _context.next = 36;
              break;
            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](21);
              if (!t.throw) {
                _context.next = 35;
                break;
              }
              _context.next = 31;
              return t.throw(_context.t0);
            case 31:
              if (!(i = !!_context.sent.done)) {
                _context.next = 33;
                break;
              }
              r(0);
            case 33:
              _context.next = 36;
              break;
            case 35:
              throw _context.t0;
            case 36:
              _context.next = 10;
              break;
            case 38:
              a = !1;
            case 39:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[21, 26]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()));
  };
}
function fromIterable(e) {
  if (e[Symbol.asyncIterator]) {
    return fromAsyncIterable(e);
  }
  return function (r) {
    var t = e[Symbol.iterator]();
    var i = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start(function (e) {
      if (1 === e) {
        i = !0;
        if (t.return) {
          t.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !i;) {
          if ((n = t.next()).done) {
            i = !0;
            if (t.return) {
              t.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (t.throw) {
                if (i = !!t.throw(e).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    }));
  };
}
var r = fromIterable;
function fromValue(e) {
  return function (r) {
    var t = !1;
    r(start(function (i) {
      if (1 === i) {
        t = !0;
      } else if (!t) {
        t = !0;
        r(push(e));
        r(0);
      }
    }));
  };
}
function make(e) {
  return function (r) {
    var t = !1;
    var i = e({
      next: function next(e) {
        if (!t) {
          r(push(e));
        }
      },
      complete: function complete() {
        if (!t) {
          t = !0;
          r(0);
        }
      }
    });
    r(start(function (e) {
      if (1 === e && !t) {
        t = !0;
        i();
      }
    }));
  };
}
function makeSubject() {
  var e;
  var r;
  return {
    source: share(make(function (t) {
      e = t.next;
      r = t.complete;
      return teardownPlaceholder;
    })),
    next: function next(r) {
      if (e) {
        e(r);
      }
    },
    complete: function complete() {
      if (r) {
        r();
      }
    }
  };
}
var empty = function empty(e) {
  var r = !1;
  e(start(function (t) {
    if (1 === t) {
      r = !0;
    } else if (!r) {
      r = !0;
      e(0);
    }
  }));
};
var never = function never(r) {
  r(start(e));
};
function interval(e) {
  return make(function (r) {
    var t = 0;
    var i = setInterval(function () {
      return r.next(t++);
    }, e);
    return function () {
      return clearInterval(i);
    };
  });
}
function fromDomEvent(e, r) {
  return make(function (t) {
    e.addEventListener(r, t.next);
    return function () {
      return e.removeEventListener(r, t.next);
    };
  });
}
function fromPromise(e) {
  return make(function (r) {
    e.then(function (e) {
      Promise.resolve(e).then(function () {
        r.next(e);
        r.complete();
      });
    });
    return teardownPlaceholder;
  });
}
function subscribe(r) {
  return function (t) {
    var i = e;
    var a = !1;
    t(function (e) {
      if (0 === e) {
        a = !0;
      } else if (0 === e.tag) {
        (i = e[0])(0);
      } else if (!a) {
        r(e[0]);
        i(0);
      }
    });
    return {
      unsubscribe: function unsubscribe() {
        if (!a) {
          a = !0;
          i(1);
        }
      }
    };
  };
}
function forEach(e) {
  return function (r) {
    subscribe(e)(r);
  };
}
function publish(e) {
  subscribe(function (e) {})(e);
}
var t = {
  done: !0
};
var toAsyncIterable = function toAsyncIterable(r) {
  return _defineProperty({}, Symbol.asyncIterator, function () {
    var i = [];
    var a = !1;
    var f = e;
    var n;
    r(function (e) {
      if (a) {} else if (0 === e) {
        if (n) {
          n = n(t);
        }
        a = !0;
      } else if (0 === e.tag) {
        (f = e[0])(0);
      } else if (n) {
        n = n({
          value: e[0],
          done: !1
        });
      } else {
        i.push(e[0]);
      }
    });
    return {
      next: function next() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!(a && !i.length)) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", t);
              case 4:
                if (!a && i.length <= 1) {
                  f(0);
                }
              case 5:
                return _context2.abrupt("return", i.length ? {
                  value: i.shift(),
                  done: !1
                } : new Promise(function (e) {
                  return n = e;
                }));
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      return: function _return() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!a) {
                  n = f(1);
                }
                a = !0;
                return _context3.abrupt("return", t);
              case 3:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }))();
      }
    };
  });
};
function toArray(r) {
  var t = [];
  var i = e;
  var a = !1;
  r(function (e) {
    if (0 === e) {
      a = !0;
    } else if (0 === e.tag) {
      (i = e[0])(0);
    } else {
      t.push(e[0]);
      i(0);
    }
  });
  if (!a) {
    i(1);
  }
  return t;
}
function toPromise(r) {
  return new Promise(function (t) {
    var i = e;
    var a;
    r(function (e) {
      if (0 === e) {
        Promise.resolve(a).then(t);
      } else if (0 === e.tag) {
        (i = e[0])(0);
      } else {
        a = e[0];
        i(0);
      }
    });
  });
}
function zip(r) {
  var t = Object.keys(r).length;
  return function (i) {
    var a = new Set();
    var f = Array.isArray(r) ? new Array(t).fill(e) : {};
    var n = Array.isArray(r) ? new Array(t) : {};
    var s = !1;
    var l = !1;
    var u = !1;
    var o = 0;
    var loop = function loop(v) {
      r[v](function (c) {
        if (0 === c) {
          if (o >= t - 1) {
            u = !0;
            i(0);
          } else {
            o++;
          }
        } else if (0 === c.tag) {
          f[v] = c[0];
        } else if (!u) {
          n[v] = c[0];
          a.add(v);
          if (!s && a.size < t) {
            if (!l) {
              for (var h in r) {
                if (!a.has(h)) {
                  (f[h] || e)(0);
                }
              }
            } else {
              l = !1;
            }
          } else {
            s = !0;
            l = !1;
            i(push(Array.isArray(n) ? n.slice() : _objectSpread({}, n)));
          }
        }
      });
    };
    for (var v in r) {
      loop(v);
    }
    i(start(function (e) {
      if (u) {} else if (1 === e) {
        u = !0;
        for (var r in f) {
          f[r](1);
        }
      } else if (!l) {
        l = !0;
        for (var t in f) {
          f[t](0);
        }
      }
    }));
  };
}
function combine() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  return zip(e);
}
var observableSymbol = function observableSymbol() {
  return Symbol.observable || "@@observable";
};
function fromObservable(e) {
  return function (r) {
    var t = (e[observableSymbol()] ? e[observableSymbol()]() : e).subscribe({
      next: function next(e) {
        r(push(e));
      },
      complete: function complete() {
        r(0);
      },
      error: function error(e) {
        throw e;
      }
    });
    r(start(function (e) {
      if (1 === e) {
        t.unsubscribe();
      }
    }));
  };
}
function toObservable(r) {
  return _defineProperty({
    subscribe: function subscribe(t, i, a) {
      var f = "object" == typeof t ? t : {
        next: t,
        error: i,
        complete: a
      };
      var n = e;
      var s = !1;
      r(function (e) {
        if (s) {} else if (0 === e) {
          s = !0;
          if (f.complete) {
            f.complete();
          }
        } else if (0 === e.tag) {
          (n = e[0])(0);
        } else {
          f.next(e[0]);
          n(0);
        }
      });
      var l = {
        closed: !1,
        unsubscribe: function unsubscribe() {
          l.closed = !0;
          s = !0;
          n(1);
        }
      };
      return l;
    }
  }, observableSymbol(), function () {
    return this;
  });
}
function fromCallbag(e) {
  return function (r) {
    e(0, function (e, t) {
      if (0 === e) {
        r(start(function (e) {
          t(e + 1);
        }));
      } else if (1 === e) {
        r(push(t));
      } else {
        r(0);
      }
    });
  };
}
function toCallbag(e) {
  return function (r, t) {
    if (0 === r) {
      e(function (e) {
        if (0 === e) {
          t(2);
        } else if (0 === e.tag) {
          t(0, function (r) {
            if (r < 3) {
              e[0](r - 1);
            }
          });
        } else {
          t(1, e[0]);
        }
      });
    }
  };
}
var pipe = function pipe() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }
  var r = e[0];
  for (var t = 1, i = e.length; t < i; t++) {
    r = e[t](r);
  }
  return r;
};
export { buffer, combine, concat, concatAll, concatMap, debounce, delay, empty, filter, mergeAll as flatten, forEach, r as fromArray, fromAsyncIterable, fromCallbag, fromDomEvent, fromIterable, fromObservable, fromPromise, fromValue, interval, lazy, make, makeSubject, map, merge, mergeAll, mergeMap, never, onEnd, onPush, onStart, pipe, publish, sample, scan, share, skip, skipUntil, skipWhile, subscribe, switchAll, switchMap, take, takeLast, takeUntil, takeWhile, onPush as tap, throttle, toArray, toAsyncIterable, toCallbag, toObservable, toPromise, zip };